export default __webpack_public_path__ + "static/media/parallelogram.3fe4d954.svg";